import React from "react";
import { useNavigate } from "react-router-dom";

function UnAuthAssessmentPopup({ setUnAuthPopup, errMsg, closingWindowFlag }) {
  const navigate = useNavigate()
  const handleRouteFunc = () => {
    const routes = localStorage.getItem("summarySideMenu");
    switch (routes) {
      case "Summary":
        navigate("/Summary")
        break;
      case "Assessment":
        navigate("/Assessment")
        break;
      default:
        navigate("/Assessment")
    }
  }

  return (
    <div className="successful_create_transprant_body">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <img className="prereadLoader" src="/images/alert.svg" alt="icon" style={{ width: "60px", height: "60px", margin: "auto" }} />
            </div>
            <div className="modal-body text-center" style={{ fontSize: "20px", fontWeight: "500" }}>
              {errMsg}
            </div>
            <hr className="my-1" />
            <div className="p-2">
              <button type="button" className="btn btn-secondary float-end" onClick={() => {
                setUnAuthPopup(false);
                if (!closingWindowFlag) {
                  handleRouteFunc()
                }
              }}>Okay</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnAuthAssessmentPopup;
